import type { TLibraryTheme } from "@up/data";

export const LIBRARY_THEME: TLibraryTheme = {
  acceptOrAdmit: "admit",
  analyticsPartnerName: "georgetown",
  buttonPrimaryClass: "app-button-primary",
  buttonSecondaryClass: "app-button-secondary",
  buttonTertiaryClass: "",
  directToCheckout: false,
  heading1Class: "text-5xl italic focus:outline-none",
  heading2Class: "text-3xl font-serif italic focus:outline-none",
  heading3Class: "text-xl font-sans font-bold",
  lmsURL: "https://app.georgetown.precollegeprograms.org",
  noGuardian: false,
  partnerID: process.env.NEXT_PUBLIC_HALL_OF_RECORDS_PARTNER_ID as string,
  partnerPrivacyPolicy: "https://www.georgetown.edu/privacy-policy",
  partnerName: "Georgetown University",
  partnerOnlineName: "Georgetown Pre-College Online Program",
  primaryColor: "#041e42",
  supportEmail: "support@precollegeonline.georgetown.edu",
  address: {
    streetAddress: "640 Massachusetts Ave NW",
    addressLocality: "Washington",
    addressRegion: "DC",
    postalCode: "20001",
    addressCountry: "US",
  },
} as const;
